import type { Action } from 'src/types';

export const CAREER_HISTORY_FORM = 'career-history-form';
export const EDUCATION_FORM = 'education-form';
export const LANGUAGES_FORM = 'languages-form';
export const LICENCES_FORM = 'licences-form';
export const NEXT_ROLE_APPROACHABILITY_FORM = 'next-role-approachability-form';
export const NEXT_ROLE_AVAILABILITY_FORM = 'next-role-availability-form';
export const NEXT_ROLE_CLASSIFICATION_FORM = 'next-role-classification-form';
export const NEXT_ROLE_PREFERRED_LOCATION_FORM =
  'next-role-preferred-location-form';
export const NEXT_ROLE_RIGHT_TO_WORK_FORM = 'next-role-right-to-work-form';
export const NEXT_ROLE_SALARY_FORM = 'next-role-salary-form';
export const NEXT_ROLE_WORK_TYPE_FORM = 'next-role-work-type-form';
export const PERSONAL_DETAILS_FORM = 'personal-details-form';
export const PREFERRED_LOCATION_FORM = 'preferred-location-form';
export const REPORT_PROFILE_FORM = 'report-profile-form';
export const RESUME_FORM = 'resume-form';
export const SKILLS_FORM = 'skills-form';
export const SUMMARY_FORM = 'summary-form';
export const YEARS_OF_EXPERIENCE_FORM = 'years-of-experience-form';

export const FORMS = [
  CAREER_HISTORY_FORM,
  EDUCATION_FORM,
  LANGUAGES_FORM,
  LICENCES_FORM,
  NEXT_ROLE_APPROACHABILITY_FORM,
  NEXT_ROLE_AVAILABILITY_FORM,
  NEXT_ROLE_CLASSIFICATION_FORM,
  NEXT_ROLE_PREFERRED_LOCATION_FORM,
  NEXT_ROLE_RIGHT_TO_WORK_FORM,
  NEXT_ROLE_SALARY_FORM,
  NEXT_ROLE_WORK_TYPE_FORM,
  PERSONAL_DETAILS_FORM,
  PREFERRED_LOCATION_FORM,
  REPORT_PROFILE_FORM,
  RESUME_FORM,
  SKILLS_FORM,
  SUMMARY_FORM,
  YEARS_OF_EXPERIENCE_FORM,
] as const;

export type Form = (typeof FORMS)[number];

export type State = Record<Form, { dirty: boolean }>;

export const initialState: State = {
  [CAREER_HISTORY_FORM]: { dirty: false },
  [EDUCATION_FORM]: { dirty: false },
  [LANGUAGES_FORM]: { dirty: false },
  [LICENCES_FORM]: { dirty: false },
  [NEXT_ROLE_APPROACHABILITY_FORM]: { dirty: false },
  [NEXT_ROLE_AVAILABILITY_FORM]: { dirty: false },
  [NEXT_ROLE_CLASSIFICATION_FORM]: { dirty: false },
  [NEXT_ROLE_PREFERRED_LOCATION_FORM]: { dirty: false },
  [NEXT_ROLE_RIGHT_TO_WORK_FORM]: { dirty: false },
  [NEXT_ROLE_SALARY_FORM]: { dirty: false },
  [NEXT_ROLE_WORK_TYPE_FORM]: { dirty: false },
  [PERSONAL_DETAILS_FORM]: { dirty: false },
  [PREFERRED_LOCATION_FORM]: { dirty: false },
  [REPORT_PROFILE_FORM]: { dirty: false },
  [RESUME_FORM]: { dirty: false },
  [SKILLS_FORM]: { dirty: false },
  [SUMMARY_FORM]: { dirty: false },
  [YEARS_OF_EXPERIENCE_FORM]: { dirty: false },
};

export const UPDATE_DIRTY_STATE = 'UPDATE_DIRTY_STATE';

export type FormAction = Action<typeof UPDATE_DIRTY_STATE> & {
  payload: {
    form: Form;
    dirty: boolean;
  };
};

export const formsReducer = (
  state: State = initialState,
  action: FormAction | any,
): State => {
  switch (action.type) {
    case UPDATE_DIRTY_STATE: {
      const { form, dirty } = action.payload;

      return {
        ...state,
        [form]: {
          dirty,
        },
      };
    }

    default:
      return state;
  }
};
